import { html } from "htm/preact";

import type * as Bible from "../modules/bible";

export const BibleContentItem = ({ item }: { item: Bible.ContentItem }) => {
  return html`<span
    data-style=${item.styleAttribute}
    part=${`bible-content-item${item.styleAttribute}`}
    >${item.content}</span
  >`;
};
